<template>
  <div class="community-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <el-form-item label="关键词">
          <el-input
              v-model="searchForm.keyword"
              placeholder="社区名称/地址"
              clearable
              style="width: 220px"
              @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="success" icon="el-icon-plus" @click="openAddDialog">新增社区</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>

        <!-- 社区封面 -->
        <el-table-column label="封面" width="80" align="center">
          <template slot-scope="{ row }">
            <el-image
                v-if="row.showLogo"
                :src="row.showLogo"
                :preview-src-list="[row.showLogo]"
                fit="cover"
                class="logo-thumb"
            >
              <div slot="error" class="logo-error"><i class="el-icon-picture-outline"></i></div>
            </el-image>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <el-table-column prop="district" label="所属街道" min-width="150"></el-table-column>
        <el-table-column prop="name" label="社区名称" min-width="150"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contactPhone" label="联系电话" width="130"></el-table-column>

        <!-- 经纬度 -->
        <el-table-column label="经纬度" width="170">
          <template slot-scope="{ row }">
            <span v-if="row.latitude !== null && row.latitude !== undefined && row.longitude !== null && row.longitude !== undefined">
              {{ row.latitude }}, {{ row.longitude }}
            </span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <!-- 营业时间 -->
        <el-table-column label="营业时间" min-width="170">
          <template slot-scope="{ row }">
            <span v-if="formatBusiness(row)">{{ formatBusiness(row) }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-switch
                v-model="row.status"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                @change="handleStatusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <!--        <el-table-column prop="createdAt" label="创建时间" width="170">-->
        <!--          <template slot-scope="{ row }">-->
        <!--            {{ formatTime(row.createdAt) }}-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="openEditDialog(row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="560px"
        @close="resetForm"
    >
      <el-form ref="communityForm" :model="form" :rules="rules" label-width="100px">
        <!-- 社区封面：走 uploadImages 传单张 -->
        <el-form-item label="社区封面" prop="logo">
          <el-upload
              class="logo-uploader"
              action="#"
              :show-file-list="false"
              :http-request="uploadLogo"
              :before-upload="beforeLogoUpload"
          >
            <img v-if="form.showLogo" :src="form.showLogo" class="logo-img" alt="封面" />
            <i v-else class="el-icon-plus logo-uploader-icon" v-loading="uploading"></i>
          </el-upload>
          <div class="el-upload__tip">建议 1:1，jpg/png，≤2MB；点击图片可重新上传</div>
        </el-form-item>

        <el-form-item label="所属街道" prop="district">
          <el-input v-model="form.district" placeholder="如:鹿城区五马街道"></el-input>
        </el-form-item>
        <el-form-item label="社区名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入社区名称"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.contactPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <!-- 经纬度 -->
        <el-form-item label="纬度" prop="latitude">
          <el-input-number
              v-model="form.latitude"
              :precision="6"
              :step="0.000001"
              :min="-90"
              :max="90"
              :controls="false"
              placeholder="如:27.998123"
              style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="经度" prop="longitude">
          <el-input-number
              v-model="form.longitude"
              :precision="6"
              :step="0.000001"
              :min="-180"
              :max="180"
              :controls="false"
              placeholder="如:120.699123"
              style="width: 100%"
          ></el-input-number>
        </el-form-item>

        <!-- 营业时间 -->
        <el-form-item label="营业时间">
          <el-time-picker
              v-model="form.businessStart"
              value-format="HH:mm"
              format="HH:mm"
              placeholder="开始"
              style="width: 132px"
          ></el-time-picker>
          <span class="time-split">-</span>
          <el-time-picker
              v-model="form.businessEnd"
              value-format="HH:mm"
              format="HH:mm"
              placeholder="结束"
              style="width: 132px"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="营业时间2" prop="business2Start">
          <el-time-picker
              v-model="form.business2Start"
              value-format="HH:mm"
              format="HH:mm"
              placeholder="开始"
              style="width: 132px"
          ></el-time-picker>
          <span class="time-split">-</span>
          <el-time-picker
              v-model="form.business2End"
              value-format="HH:mm"
              format="HH:mm"
              placeholder="结束"
              style="width: 132px"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCommunityList, saveCommunity, deleteCommunity } from '@/api/community'
// 按项目实际路径调整；uploadImages(files, bizType) 内部走 /manage/merchant/uploadImages
import { uploadImages } from '@/api/upload'

// 图片访问域名：库里存的是 fileUrls 里的相对路径，展示时用它拼成完整 URL
const IMG_BASE_URL = 'https://community.sparetimeup.cn/img/'

const emptyForm = () => ({
  id: null,
  name: '',
  address: '',
  district: '',
  contactPhone: '',
  logo: '',
  showLogo: '',
  latitude: null,
  longitude: null,
  status: 1,
  businessStart: '',
  businessEnd: '',
  business2Start: '',
  business2End: ''
})

export default {
  name: 'CommunityList',
  data() {
    // 经纬度：要么都填，要么都不填
    const checkLocation = (rule, value, callback) => {
      const { latitude, longitude } = this.form
      const latEmpty = latitude === null || latitude === undefined || latitude === ''
      const lngEmpty = longitude === null || longitude === undefined || longitude === ''
      if (latEmpty && lngEmpty) return callback()
      if (latEmpty || lngEmpty) return callback(new Error('经纬度需成对填写'))
      if (Number(latitude) < -90 || Number(latitude) > 90) return callback(new Error('纬度范围为 -90 ~ 90'))
      if (Number(longitude) < -180 || Number(longitude) > 180) return callback(new Error('经度范围为 -180 ~ 180'))
      callback()
    }
    // 营业时段：成对填写 + 结束晚于开始（不覆盖跨夜场景）
    const checkTimeRange = (startKey, endKey) => (rule, value, callback) => {
      const s = this.form[startKey]
      const e = this.form[endKey]
      if (!s && !e) return callback()
      if (!s || !e) return callback(new Error('营业时间需成对填写'))
      if (String(s) >= String(e)) return callback(new Error('结束时间需晚于开始时间'))
      callback()
    }

    return {
      searchForm: { keyword: '' },
      tableData: [],
      loading: false,
      uploading: false,
      page: 1,
      size: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增社区',
      submitting: false,
      form: emptyForm(),
      rules: {
        district: [{ required: true, message: '请输入所属街道', trigger: 'blur' }],
        name: [{ required: true, message: '请输入社区名称', trigger: 'blur' }],
        // address: [{ required: true, message: '请输入地址', trigger: 'blur' }]
        latitude: [{ validator: checkLocation, trigger: 'change' }],
        longitude: [{ validator: checkLocation, trigger: 'change' }],
        business2Start: [{ validator: checkTimeRange('business2Start', 'business2End'), trigger: 'change' }]
      }
    }
  },
  mounted() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getCommunityList(this.searchForm.keyword, this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        // 每行补 showLogo：后端若已返回则直接用，否则用域名 + logo 拼接
        this.tableData = (Array.isArray(list) ? list : []).map(row => ({
          ...row,
          showLogo: row.showLogo || this.toShowUrl(row.logo)
        }))
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.loadData() },
    resetSearch() { this.searchForm.keyword = ''; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },

    openAddDialog() {
      this.dialogTitle = '新增社区'
      this.form = emptyForm()
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.dialogTitle = '编辑社区'
      this.form = {
        ...emptyForm(),
        ...row,
        // 兜底：接口缺失字段时给出安全的默认值
        logo: row.logo || '',
        showLogo: row.showLogo || this.toShowUrl(row.logo),
        latitude: row.latitude === null || row.latitude === undefined ? null : Number(row.latitude),
        longitude: row.longitude === null || row.longitude === undefined ? null : Number(row.longitude),
        status: row.status === 0 ? 0 : 1
      }
      this.dialogVisible = true
    },
    resetForm() {
      this.$refs.communityForm && this.$refs.communityForm.resetFields()
    },

    /* ---------- 封面上传：uploadImages 传单张 ---------- */
    beforeLogoUpload(file) {
      const isImg = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'].indexOf(file.type) > -1
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) this.$message.error('封面只能是 jpg/png/webp 格式')
      if (!isLt2M) this.$message.error('封面大小不能超过 2MB')
      return isImg && isLt2M
    },
    uploadLogo({ file, onSuccess, onError }) {
      this.uploading = true
      return uploadImages([file], 'community_logo') // 单张：数组里只放一个文件
          .then(res => {
            const { logo, showLogo } = this.pickUploadUrl(res)
            if (!logo) {
              this.$message.error('上传失败：未返回图片地址')
              onError(new Error('no url'))
              return
            }
            // logo 存库（相对路径），showLogo 仅用于页面展示（完整 URL）
            this.form.logo = logo
            this.form.showLogo = showLogo
            this.$refs.communityForm && this.$refs.communityForm.clearValidate('logo')
            onSuccess({ url: showLogo })
          })
          .catch(err => {
            this.$message.error('封面上传失败，请重试')
            onError(err)
          })
          .finally(() => { this.uploading = false })
    },
    // 解析上传返回：{ data: { fileUrls: [相对路径], showFileUrls: [完整URL] } }
    // 返回 { logo: 存储值, showLogo: 展示值 }
    pickUploadUrl(res) {
      const d = (res && res.data) || res || {}
      const fileUrls = d.fileUrls || d.fileUrl || []
      const showFileUrls = d.showFileUrls || d.showFileUrl || []
      const logo = Array.isArray(fileUrls) ? fileUrls[0] : fileUrls
      let showLogo = Array.isArray(showFileUrls) ? showFileUrls[0] : showFileUrls
      if (!showLogo) showLogo = this.toShowUrl(logo)
      return { logo: logo || '', showLogo: showLogo || '' }
    },
    // 相对路径 -> 完整访问地址；本身已是 http(s) 则原样返回
    toShowUrl(logo) {
      if (!logo) return ''
      return /^https?:\/\//i.test(logo) ? logo : IMG_BASE_URL + String(logo).replace(/^\/+/, '')
    },

    handleSubmit() {
      this.$refs.communityForm.validate(async valid => {
        if (!valid) return
        // 营业时间1 的成对/先后校验（未在 rules 中绑定，提交时补校验）
        const err = this.validateBusinessTime()
        if (err) { this.$message.warning(err); return }
        this.submitting = true
        try {
          await saveCommunity(this.buildPayload())
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.loadData()
        } catch (e) {} finally {
          this.submitting = false
        }
      })
    },
    buildPayload() {
      const f = { ...this.form }
      delete f.showLogo // 展示用字段，不提交后端
      ;['businessStart', 'businessEnd', 'business2Start', 'business2End'].forEach(k => {
        f[k] = f[k] || null // 未填则清空，避免写入空串
      })
      return f
    },
    validateBusinessTime() {
      const { businessStart: s, businessEnd: e } = this.form
      if (!s && !e) return ''
      if (!s || !e) return '营业时间需成对填写'
      if (String(s) >= String(e)) return '营业时间：结束时间需晚于开始时间'
      return ''
    },

    // 状态切换：复用 save 接口只提交 id + status；如后端有独立状态接口，替换为对应 api 即可
    async handleStatusChange(row) {
      const target = row.status
      try {
        await saveCommunity({ id: row.id, status: target })
        this.$message.success(target === 1 ? '已启用' : '已停用')
      } catch (e) {
        row.status = target === 1 ? 0 : 1
      }
    },

    handleDelete(row) {
      this.$confirm(`确认删除社区「${row.name}」吗？`, '提示', { type: 'warning' })
          .then(async () => {
            await deleteCommunity(row.id)
            this.$message.success('删除成功')
            this.loadData()
          })
          .catch(() => {})
    },

    formatBusiness(row) {
      const seg1 = row.businessStart && row.businessEnd ? `${row.businessStart}-${row.businessEnd}` : ''
      const seg2 = row.business2Start && row.business2End ? `${row.business2Start}-${row.business2End}` : ''
      return [seg1, seg2].filter(Boolean).join(' / ')
    },
    formatTime(t) {
      if (!t) return '-'
      return new Date(t).toLocaleString('zh-CN', { hour12: false })
    }
  }
}
</script>

<style scoped>
.community-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
.text-muted { color: #c0c4cc; }

.logo-thumb { width: 44px; height: 44px; border-radius: 4px; display: block; margin: 0 auto; background: #f5f7fa; }
.logo-error { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; color: #c0c4cc; }

.logo-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-uploader >>> .el-upload:hover { border-color: #409eff; }
.logo-uploader-icon { font-size: 28px; color: #8c939d; width: 100px; line-height: 100px; text-align: center; }
.logo-img { width: 100px; height: 100px; display: block; object-fit: cover; }

.time-split { margin: 0 8px; color: #909399; }
</style>
